export enum OSType {
  Android,
  iOs,
  Mac,
  Windows,
  Linux,
  Unknown,
}
